// Preserve the methods before blocking so an authenticated runtime decision can restore them.
const originalConsoleMethods: Pick<Console, 'log' | 'info' | 'debug'> = {
  log: console.log,
  info: console.info,
  debug: console.debug,
};

/** Discard console arguments without inspecting, formatting or retaining their values. */
function discardConsoleOutput(): void {}

/** Apply an explicit boolean decision; warnings and errors are never modified. */
export function applyConsolePolicy(allowLogs: boolean = false): void {
  console.log = allowLogs === true ? originalConsoleMethods.log : discardConsoleOutput;
  console.info = allowLogs === true ? originalConsoleMethods.info : discardConsoleOutput;
  console.debug = allowLogs === true ? originalConsoleMethods.debug : discardConsoleOutput;
}

// Fail closed before application imports or session initialization can produce ordinary logs.
applyConsolePolicy();
